const snmpOid = {
  '1.3.6.1.2.1.1.3.0': 'sysUpTime',
  '1.3.6.1.4.1.46911.1.2.1.1.0': 'cpuCurrent',
  '1.3.6.1.4.1.46911.1.2.1.2.0': 'cpuAlarmState',
  '1.3.6.1.4.1.46911.1.2.1.3.0': 'cpuAlarmThreshold',
  '1.3.6.1.4.1.46911.1.2.1.4.0': 'cpuAlarmHysteresis',
  '1.3.6.1.4.1.46911.1.2.2.1.0': 'diskSystemVolumeCurrent',
  '1.3.6.1.4.1.46911.1.2.2.2.0': 'diskSystemAlarmState',
  '1.3.6.1.4.1.46911.1.2.2.3.0': 'diskSystemAlarmThreshold',
  '1.3.6.1.4.1.46911.1.2.2.4.0': 'diskSystemAlarmHysteresis',
  '1.3.6.1.4.1.46911.1.2.3.1.0': 'diskUserVolumeCurrent',
  '1.3.6.1.4.1.46911.1.2.3.2.0': 'diskUserAlarmState',
  '1.3.6.1.4.1.46911.1.2.3.3.0': 'diskUserAlarmThreshold',
  '1.3.6.1.4.1.46911.1.2.3.4.0': 'diskUserAlarmHysteresis',
  '1.3.6.1.4.1.46911.1.2.4.1.0': 'doorStateCurrent',
  '1.3.6.1.4.1.46911.1.2.4.2.0': 'doorThreshold',
  '1.3.6.1.4.1.46911.1.2.5.1.0': 'gpsStatusCurrent',
  '1.3.6.1.4.1.46911.1.2.5.2.0': 'gpsThreshold',
  '1.3.6.1.4.1.46911.1.2.6.1.0': 'ramCurrent',
  '1.3.6.1.4.1.46911.1.2.6.2.0': 'ramAlarmState',
  '1.3.6.1.4.1.46911.1.2.6.3.0': 'ramAlarmThreshold',
  '1.3.6.1.4.1.46911.1.2.6.4.0': 'ramAlarmHysteresis',
  '1.3.6.1.4.1.46911.1.2.7.1.0': 'rssiCurrent',
  '1.3.6.1.4.1.46911.1.2.7.2.0': 'rssiAlarmState',
  '1.3.6.1.4.1.46911.1.2.7.3.0': 'rssiAlarmThreshold',
  '1.3.6.1.4.1.46911.1.2.7.4.0': 'rssiAlarmHysteresis',
  '1.3.6.1.4.1.46911.1.2.8.1.0': 'temperatureCurrent',
  '1.3.6.1.4.1.46911.1.2.8.2.0': 'temperatureAlarmState',
  '1.3.6.1.4.1.46911.1.2.8.3.0': 'temperatureAlarmThreshold',
  '1.3.6.1.4.1.46911.1.2.8.4.0': 'temperatureAlarmHysteresis',
  '1.3.6.1.4.1.46911.10.1.0': 'addressType',
  '1.3.6.1.4.1.46911.10.2.0': 'address',
  '1.3.6.1.4.1.46911.10.3.0': 'managerPort',
  '1.3.6.1.4.1.46911.10.4.0': 'managerCommunity',
  '1.3.6.1.4.1.46911.10.5.0': 'agentPort',
  '1.3.6.1.4.1.46911.10.6.0': 'applyChanges',
  '1.3.6.1.4.1.46911.11.1.0': 'installDate',
  '1.3.6.1.4.1.46911.11.2.0': 'sourceFile',
  '1.3.6.1.4.1.46911.11.3.0': 'updateTransactionId',
  '1.3.6.1.4.1.46911.11.4.0': 'updateCommand',
  '1.3.6.1.4.1.46911.11.5.0': 'updateStatus',
  '1.3.6.1.4.1.46911.11.6.0': 'updateFailCause',
  '1.3.6.1.4.1.46911.12.1.0': 'sourceFileTransfer',
  '1.3.6.1.4.1.46911.12.2.0': 'destinationFileTransfer',
  '1.3.6.1.4.1.46911.12.3.0': 'direction',
  '1.3.6.1.4.1.46911.12.4.0': 'copyTransactionId',
  '1.3.6.1.4.1.46911.12.5.0': 'copyCommand',
  '1.3.6.1.4.1.46911.12.6.0': 'copyStatus',
  '1.3.6.1.4.1.46911.12.7.0': 'copyFailCause',
  '1.3.6.1.4.1.46911.13.1': 'spectrumsTable',
  '1.3.6.1.4.1.46911.13.1.1.2': 'duration',
  '1.3.6.1.4.1.46911.13.1.1.3': 'destinationFileName',
  '1.3.6.1.4.1.46911.13.1.1.4': 'modemSerialNumber',
  '1.3.6.1.4.1.46911.13.1.1.5': 'spectrumTransactionId',
  '1.3.6.1.4.1.46911.13.1.1.6': 'spectrumCommand',
  '1.3.6.1.4.1.46911.13.1.1.7': 'spectrumStatus',
  '1.3.6.1.4.1.46911.13.1.1.8': 'spectrumFailCause',
  '1.3.6.1.4.1.46911.14.1.0': 'input',
  '1.3.6.1.4.1.46911.14.2.0': 'output',
  '1.3.6.1.4.1.46911.14.3.0': 'commandTransactionId',
  '1.3.6.1.4.1.46911.14.4.0': 'command',
  '1.3.6.1.4.1.46911.14.5.0': 'commandStatus',
  '1.3.6.1.4.1.46911.14.6.0': 'commandFailCause',
  '1.3.6.1.4.1.46911.2.0': 'interfaceVersion',
  '1.3.6.1.4.1.46911.3.0': 'gatewayEui',
  '1.3.6.1.4.1.46911.4.0': 'wanCurrentInterface',
  '1.3.6.1.4.1.46911.5.0': 'deviceType',
  '1.3.6.1.4.1.46911.50.1.1.0': 'hashVersions',
  '1.3.6.1.4.1.46911.50.1.2.0': 'versionsNumber',
  '1.3.6.1.4.1.46911.50.1.3': 'versionsTable',
  '1.3.6.1.4.1.46911.50.1.3.1.1': 'versionIndex',
  '1.3.6.1.4.1.46911.50.1.3.1.2': 'versionDescr',
  '1.3.6.1.4.1.46911.50.1.500.0': 'uidVersions',
  '1.3.6.1.4.1.46911.50.12.1.0': 'location',
  '1.3.6.1.4.1.46911.50.12.2.1.0': 'gsmType',
  '1.3.6.1.4.1.46911.50.12.2.2.0': 'gsmDescr',
  '1.3.6.1.4.1.46911.50.12.2.3.0': 'imei',
  '1.3.6.1.4.1.46911.50.12.2.4.0': 'iccId',
  '1.3.6.1.4.1.46911.50.12.3.1.0': 'wlanType',
  '1.3.6.1.4.1.46911.50.12.3.2.0': 'firmwareDescr',
  '1.3.6.1.4.1.46911.50.13.1.0': 'modulesNumber',
  '1.3.6.1.4.1.46911.50.13.2': 'lanRadiosTable',
  '1.3.6.1.4.1.46911.50.13.2.1.1': 'lanRadioIndex',
  '1.3.6.1.4.1.46911.50.13.2.1.10': 'lanRadioCentralFrequency',
  '1.3.6.1.4.1.46911.50.13.2.1.11': 'lanRadioRfPathNumber',
  '1.3.6.1.4.1.46911.50.13.2.1.12': 'lanRadioPathWidth',
  '1.3.6.1.4.1.46911.50.13.2.1.13': 'lanRadioMinTxFrequency',
  '1.3.6.1.4.1.46911.50.13.2.1.14': 'lanRadioMaxTxFrequency',
  '1.3.6.1.4.1.46911.50.13.2.1.15': 'lanRadioMinRxFrequency',
  '1.3.6.1.4.1.46911.50.13.2.1.16': 'lanRadioMaxRxFrequency',
  '1.3.6.1.4.1.46911.50.13.2.1.2': 'lanRadioId',
  '1.3.6.1.4.1.46911.50.13.2.1.3': 'lanRadioType',
  '1.3.6.1.4.1.46911.50.13.2.1.4': 'lanRadioLocation',
  '1.3.6.1.4.1.46911.50.13.2.1.5': 'lanRadioHwVersion',
  '1.3.6.1.4.1.46911.50.13.2.1.6': 'lanRadioFrontRfHwVersion',
  '1.3.6.1.4.1.46911.50.13.2.1.7': 'lanRadioSwVersion',
  '1.3.6.1.4.1.46911.50.13.2.1.8': 'lanRadioAntennaNumber',
  '1.3.6.1.4.1.46911.50.13.2.1.9': 'lanRadioRfFrontInputPathNumber',
  '1.3.6.1.4.1.46911.50.14.1.0': 'hashConfiguration',
  '1.3.6.1.4.1.46911.50.14.2.1.0': 'rollbackTmoMn',
  '1.3.6.1.4.1.46911.50.14.2.2.0': 'statsPeriod',
  '1.3.6.1.4.1.46911.50.14.2.3.0': 'whitelist',
  '1.3.6.1.4.1.46911.50.14.3.1.0': 'configRadio',
  '1.3.6.1.4.1.46911.50.14.3.2.1.0': 'pwrThreshold',
  '1.3.6.1.4.1.46911.50.14.3.2.2.0': 'durationThreshold',
  '1.3.6.1.4.1.46911.50.14.4.1.0': 'sourceAux',
  '1.3.6.1.4.1.46911.50.14.4.2.1.0': 'periodResolution',
  '1.3.6.1.4.1.46911.50.14.4.2.2.0': 'ntp1',
  '1.3.6.1.4.1.46911.50.14.4.2.3.0': 'ntp2',
  '1.3.6.1.4.1.46911.50.14.4.3.0': 'ptpMaster',
  '1.3.6.1.4.1.46911.50.14.5.1.0': 'configVpn',
  '1.3.6.1.4.1.46911.50.14.6.1': 'wanInterfacesPriorityTable',
  '1.3.6.1.4.1.46911.50.14.6.1.1.1': 'wanInterfaceIndex',
  '1.3.6.1.4.1.46911.50.14.6.1.1.2': 'wanInterfaceType',
  '1.3.6.1.4.1.46911.50.14.6.2.1.0': 'apn',
  '1.3.6.1.4.1.46911.50.14.6.2.2.0': 'pinCode',
  '1.3.6.1.4.1.46911.50.14.6.2.3.0': 'login',
  '1.3.6.1.4.1.46911.50.14.6.2.4.0': 'password',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.1.1': 'MCC.1',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.1.2': 'MCC.2',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.1.3': 'MCC.3',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.1.4': 'MCC.4',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.1.5': 'MCC.5',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.1.6': 'MCC.6',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.1.7': 'MCC.7',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.1.8': 'MCC.8',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.1.9': 'MCC.9',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.1.10': 'MCC.10',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.2.1': 'MNC.1',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.2.2': 'MNC.2',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.2.3': 'MNC.3',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.2.4': 'MNC.4',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.2.5': 'MNC.5',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.2.6': 'MNC.6',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.2.7': 'MNC.7',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.2.8': 'MNC.8',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.2.9': 'MNC.9',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.2.10': 'MNC.10',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.3.1': 'APN.1',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.3.2': 'APN.2',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.3.3': 'APN.3',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.3.4': 'APN.4',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.3.5': 'APN.5',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.3.6': 'APN.6',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.3.7': 'APN.7',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.3.8': 'APN.8',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.3.9': 'APN.9',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.3.10': 'APN.10',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.4.1': ' Login.1',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.4.2': ' Login.2',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.4.3': ' Login.3',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.4.4': ' Login.4',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.4.5': ' Login.5',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.4.6': ' Login.6',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.4.7': ' Login.7',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.4.8': ' Login.8',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.4.9': ' Login.9',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.4.10': ' Login.10',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.5.1': 'Password.1',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.5.2': 'Password.2',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.5.3': 'Password.3',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.5.4': 'Password.4',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.5.5': 'Password.5',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.5.6': 'Password.6',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.5.7': 'Password.7',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.5.8': 'Password.8',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.5.9': 'Password.9',
  '1.3.6.1.4.1.46911.50.14.6.2.5.1.5.10': 'Password.10',
  '1.3.6.1.4.1.46911.50.14.6.3.1.0': 'dhcp',
  '1.3.6.1.4.1.46911.50.14.6.3.2.0': 'defaultIp',
  '1.3.6.1.4.1.46911.50.14.6.3.3.0': 'defaultNetmask',
  '1.3.6.1.4.1.46911.50.14.6.3.4.0': 'defaultGateway',
  '1.3.6.1.4.1.46911.50.14.6.4.1.0': 'ssid',
  '1.3.6.1.4.1.46911.50.14.6.4.2.0': 'mode',
  '1.3.6.1.4.1.46911.50.14.6.4.3.0': 'passwordWlan',
  '1.3.6.1.4.1.46911.50.14.500.0': 'uidConfiguration',
  '1.3.6.1.4.1.46911.50.15.1.0': 'statisticsList',
  '1.3.6.1.4.1.46911.50.15.2': 'statisticsTable',
  '1.3.6.1.4.1.46911.50.15.2.1.2': 'statisticSlot',
  '1.3.6.1.4.1.46911.50.2.0': 'bootCause',
  '1.3.6.1.6.3.1.1.4.1.0': 'snmpTrapOID',
  '1.3.6.1.6.3.1.1.4.3.0': 'snmpTrapEnterprise',
  '1.3.6.1.6.3.1.1.6.1.0': 'snmpSetSerialNo'
}

// Export all by default
export default snmpOid
